<template>
  <!-- :class="{ 'pad-top': !state.token }" -->
  <div class="main">
    <!-- <SideBar v-if="state.token" /> -->
    <div :class="{ 'is-auth-otc pad-right': state.token }" class="otc">
      <BuyCrypto />
    </div>
  </div>
</template>
<script>
// import SideBar from "../Public/SideBar.vue";

import BuyCrypto from "./BuyCrypto.vue";
export default {
  components: {
    // SideBar,
    BuyCrypto,
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: var(--home-background);
}
.pad-top {
  padding-top: 75px;
}
.pad-right {
  padding-right: 36px;
}
.otc {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--home-background);
  min-height: calc(100vh - 73px);
  margin: 0 12px;
}
.is-auth-otc {
  min-height: calc(100vh - 56px);
}
</style>
